import { Box, Typography, Paper } from '@mui/material';
import CopyableText from '../../SharedArea/CopyableText';

const ActiveUsersChart = ({ data, onSelectUser }) => {
    return (
        <Box sx={{ height: 'calc(100vh - 135px)', overflowY: 'auto', p: 2 }}>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                    justifyContent: 'center',
                    direction: 'rtl',
                }}
            >
                {data.map((user, index) => (
                    <Paper
                        key={index}
                        sx={{
                            width: '100%',
                            maxWidth: 300,
                            flexGrow: 1,
                            p: 2,
                            boxSizing: 'border-box',
                            textAlign: 'center',
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                cursor: 'pointer',
                                color: 'primary.main',
                                textDecoration: 'underline',
                            }}
                            onClick={() => onSelectUser?.(user.email)}
                        >
                            {user.name}
                        </Typography>

                        <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
                            <CopyableText text={user.email} />
                        </Box>

                        <Typography variant="body1" sx={{ mt: 1 }}>
                            כמות קריאות: {user.totalRequests.toLocaleString()}
                        </Typography>
                    </Paper>
                ))}
            </Box>
        </Box>
    );
};

export default ActiveUsersChart;
